<div *ngIf="!isLoading">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
        printSectionId="print-section"  [useExistingCss]="true"  ngxPrint>
      Print
      </button>

      <button (click)="printPage()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
    Print
    </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="exportExcel('Advt_Invoice_Register')"
            mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
</div>  

<ng-container *ngIf="filteredAdvtInvoiceDatamonthly && filteredAdvtInvoiceDatamonthly.length > 0">
  <div  id="print-section" style="margin: 0; padding: 20mm 15mm;">
    <style>
   @media print {
  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  body {
    margin: 0;
    padding: 8px;
    font-family: Arial, sans-serif;
    font-size: 10pt;
    line-height: 1.3;
    text-align: center;
  }

  #print-section {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    padding: 15px;
  }

  .table {
    border-collapse: collapse;
    font-size: 12px;
    table-layout: fixed;
    width: auto;
    max-width: 190mm;
    margin: 0 auto;
  }

  .table th, .table td {
    border: 1px solid #000;
    padding: 6px 8px;
    text-align: center;
    vertical-align: middle;
    word-wrap: break-word;
    font-size: 12px;
  }

  .table th {
    background-color: #f0f0f0;
    font-weight: bold;
    padding: 8px 10px;
    font-size: 12px;
  }

  .table thead th {
    font-size: 12px;
  }

  .table thead th:first-child {
    font-size: 12px;
  }

  .table tfoot td {
    padding: 8px 10px;
    font-size: 12px;
    font-weight: bold;
  }
}

/* Screen styles for better visibility */
.table {
  font-size: 14px;
  margin: 20px auto;
  max-width: 100%;
}

.table th, .table td {
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  text-align: center;
  vertical-align: middle;
}

.table th {
  background-color: #f8f9fa;
  font-weight: bold;
  padding: 10px 12px;
}

.table tfoot td {
  padding: 10px 12px;
  font-weight: bold;
  background-color: #f8f9fa;
}
    </style>
    
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="8" style="font-size: 14pt; font-weight: bold; padding: 12px;">हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - जाहिरात विभाग</th>
          <th colspan="2" style="font-weight: bold; padding: 8px;">दिनांक - {{ today | date: "dd-MM-yyyy" }}</th>
          <th colspan="1" style="font-weight: bold; padding: 8px;">पृष्ठ क्र. - 1</th>
        </tr>
        <tr>
          <th colspan="4" style="font-weight: bold; padding: 8px;">Advt Invoice Register</th>
          <th colspan="2" style="font-weight: bold; padding: 8px;">Monthwise</th>
          <!-- <th colspan="1" style="font-weight: bold; padding: 8px;">Date</th> -->
          <th colspan="5" style="font-weight: bold; padding: 8px;">From :- {{ startDate | date: "dd-MM-yyyy" }} To :- {{ endDate | date: "dd-MM-yyyy" }}</th>
          <!-- <th colspan="" style="font-weight: bold; padding: 8px;"></th> -->
        </tr>
        <tr style="background-color: #e9ecef;">
          <th style="min-width: 80px; font-weight: bold; padding: 10px 8px;">Invoice<br>Month</th>
          <th style="min-width: 80px; font-weight: bold; padding: 10px 8px;">Advt<br>Amount</th>
          <th style="min-width: 80px; font-weight: bold; padding: 10px 8px;">Discount<br>Amount</th>
          <th style="min-width: 85px; font-weight: bold; padding: 10px 8px;">Amount<br>Before GST</th>
          <th style="min-width: 60px; font-weight: bold; padding: 10px 8px;">CGST</th>
          <th style="min-width: 60px; font-weight: bold; padding: 10px 8px;">SGST</th>
          <th style="min-width: 60px; font-weight: bold; padding: 10px 8px;">IGST</th>
          <th style="min-width: 70px; font-weight: bold; padding: 10px 8px;">Total GST</th>
          <th style="min-width: 85px; font-weight: bold; padding: 10px 8px;">Total<br>Inv. Amount</th>
          <th style="min-width: 80px; font-weight: bold; padding: 10px 8px;">Paid<br>Amount</th>
          <th style="min-width: 80px; font-weight: bold; padding: 10px 8px;">Unpaid<br>Amount</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of filteredAdvtInvoiceDatamonthly; let i = index">
          <tr *ngIf="data">
            <td style="text-align: left; padding: 8px 12px;font-weight: bold;font-size: 14px;">{{data.month}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.advt_amt }}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.total_discount_rate}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.beforegst_amount}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.cgst}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.sgst}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.igst}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.gst}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.amount}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.received_amt}}</td>
            <td class="text-end" style="text-align: right; padding: 8px 12px;font-size: 14px;">{{ data.pending_amt}}</td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr style="background-color: #f8f9fa; font-weight: bold;">
          <td style="text-align: center; font-weight: bold; background-color: #dee2e6; padding: 10px 12px;">Total</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ advtamount}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ discountamt }}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ beforegstamount }}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ tcgst}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ tsgst}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ tigst}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ tgst}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ invoicetotalamount}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ rcvamount}}</td>
          <td class="text-end fw-bold" style="text-align: right; padding: 10px 12px;font-size: 14px;">{{ UnpaidAmount}}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</ng-container>

  
</div>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>